// eslint-disable-next-line import/no-cycle
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  data: [],
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
